import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import ErrorPage from './styled';

const enhance = compose(withTranslation('Error'));

export default enhance(ErrorPage);
